const COACHING_COURSE_TYPES = new Set(['time_based_coach', 'call_based_coach']);

// True for course-list items that have coaching attached. Legacy supports both
// time-based and call-based coaching. Keep the forgiving regex for future
// variants (e.g., "subscription_coach", "premium_coach"). Centralize here so
// the sidebar, course filters, and coaching routes all share one definition.

export function isCoachedCourse(course) {
  const t = course?.course_type ?? '';
  return COACHING_COURSE_TYPES.has(t) || /coach/i.test(t);
}
